<template>
    <div class="maintenance">
      <h1>現在メンテナンス中です</h1>
      <p>We're currently down for maintenance. Please check back later.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Maintenance'
  };
  </script>
  
  <style scoped>
  .maintenance {
    text-align: center;
    margin-top: 50px;
  }
  </style>
  